import generateBootFunc from '../../generate-boot';
import resource from "../../Util/resources";

import Index from "./Components/JourneyBuilderIndex.vue";
import Overview from "./Components/Overview/JourneyBuilderOverview.vue";
import JourneyStatistics from './Components/JourneyStatistics.vue';

const bootIndex = generateBootFunc(Index, 'journey-builder-index');
const bootOverview = generateBootFunc(Overview, 'journey-builder-overview');

import DefaultLayout from "../../Components/Layout/DefaultLayout.vue";

const routes = [{
    //TODO: Fix once we get more client side routes
    path: '/JourneyBuilder/Overview/',
    alias: '/JourneyBuilder/',
    component: DefaultLayout,
    meta: {
        isMvcRoute: true,
        breadcrumb: resource('BreadCrumb_JourneyBuilder_Overview')
    },
    children: [{
        name: 'view-statistics',
        path: 'JourneyReport/:id?',
        component: JourneyStatistics,
        meta: {
            title: resource('JourneyBuilder_JourneyStatistics_Title'),
            header: resource('JourneyBuilder_JourneyStatistics_Title'),
            breadcrumb: resource('Breadcrumb_JourneyBuilder_JourneyStatistics')
        }
    }]
}];

export {
    bootIndex,
    bootOverview,

    routes
};